import React, { useState, useEffect } from 'react'

import { Layout, Row, Col } from 'antd'
import { get, map } from 'lodash'
import { useTranslation } from 'react-i18next'
import { useSelector, useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'

import { Search, TopicCard, TopicTitle, QuickStartCard, Collapse } from '../components'
import { getFaqs } from '../redux/actions/faqs'
import { getWelcome } from '../redux/actions/welcome'
import { getConfig } from '../utils'

// import PropTypes from 'prop-types'

const { Content, Footer } = Layout

const Home = () => {
  const [hideFaq, setHideFaq] = useState(true)
  const history = useHistory()
  const { i18n } = useTranslation()
  const dispatch = useDispatch()

  const [commonContent, welcomeContent, faqsContent] = useSelector((state) => [
    get(state, 'common.data', {}),
    get(state, 'welcome.data', {}),
    get(state, 'faqs.data', []),
  ])

  useEffect(() => {
    dispatch(getWelcome(i18n.language))
  }, [i18n.language])

  useEffect(() => {
    if (hideFaq) {
      dispatch(getFaqs(i18n.language, get(welcomeContent, 'faq.limitHide', 0)))
    } else {
      dispatch(getFaqs(i18n.language))
    }
  }, [welcomeContent, hideFaq])

  const handleOnClickTopic = (path) => {
    history.push(path)
  }

  const handleSeemore = () => {
    setHideFaq(!hideFaq)
  }
  return (
    <Content>
      <section className="container-fluid home__content">
        <Row justify="center" align="middle">
          <Col flex="0 0 25%" className="home__contentleft">
            <img className="banner" alt="banner" src="/assets/images/banner.svg" />
          </Col>
          <Col flex="1 0 25%" className="home__contentright">
            <h1 className="title">{get(commonContent, 'title', '')}</h1>
            <Search placeholder={get(commonContent, 'search_placeholder', '')} />
            <p className="description">{get(commonContent, 'subtitle', '')}</p>
          </Col>
        </Row>
      </section>
      <section className="container-fluid quickstart__content">
        <Row justify="center" align="middle">
          <TopicTitle text={get(commonContent, 'quickstartGuides', '')} />
        </Row>
        <Row justify="center" align="middle">
          <Col xs={24} md={20} xl={16} xxl={12}>
            <Row justify="center" gutter={[16, 16]}>
              {map(get(welcomeContent, 'quickstartGuides.quickstart_guides', []), (v, key) => (
                <Col key={`${key}`} xs={24} sm={24} md={12}>
                  <QuickStartCard
                    title={v.title}
                    subTitle={v.subtitle}
                    iconName={v.iconName}
                    onClick={() => handleOnClickTopic(`/category/${v.slug}`)}
                  />
                </Col>
              ))}
            </Row>
          </Col>
        </Row>
      </section>
      <section className="container-fluid topic__content">
        <Row justify="center" align="middle">
          <TopicTitle text={get(commonContent, 'popularTopics', '')} />
        </Row>
        <Row justify="center" align="middle">
          <Col xs={24} md={20} xl={16} xxl={12}>
            <Row justify="center" gutter={[16, 16]}>
              {map(get(welcomeContent, 'popularTopics.popular_topics', []), (v, key) => (
                <Col key={`${key}`} xs={24} sm={12} md={8}>
                  <TopicCard
                    title={v.title}
                    iconName={v.iconName}
                    onClick={() => handleOnClickTopic(`/category/${v.slug}`)}
                  />
                </Col>
              ))}
            </Row>
          </Col>
        </Row>
      </section>
      <section className="container-fluid faq__content">
        <Row justify="center" align="middle">
          <TopicTitle text={get(welcomeContent, 'faq.title', '')} />
        </Row>
        <Row justify="center" align="middle">
          <Col xs={24} md={20} xl={16} xxl={12}>
            {map(faqsContent, (i, key) => (
              <Collapse
                key={`${key}`}
                header={i.label}
                collection={i.FAQ}
                hostApi={getConfig('HOST_API')}
              />
            ))}
          </Col>
        </Row>
        <Row justify="center" style={{ margin: 24 }}>
          <Col>
            <button className="faq__seemore" onClick={handleSeemore}>
              <span>
                {hideFaq
                  ? get(welcomeContent, 'faq.seeMore', '')
                  : get(welcomeContent, 'faq.hide', '')}
              </span>
            </button>
          </Col>
        </Row>
      </section>
      <section className="container-fluid download__content">
        <div className="back-red" />
        <Row justify="center" align="stretch">
          <Col xs={24} xl={{ span: 6, order: 2 }} xxl={5}>
            <div className="download__contentright">
              <div className="wrapper-banner" />
              <img className="banner" alt="download" src="/assets/images/downloadApp.svg" />
            </div>
          </Col>
          <Col
            xs={24}
            sm={14}
            md={14}
            lg={14}
            xl={{ span: 10, order: 1 }}
            xxl={8}
            className="download__contentleft"
          >
            <h2 className="title">{get(welcomeContent, 'download.title', '')}</h2>
            <p className="description typography__paragraph">
              {get(welcomeContent, 'download.subtitle', '')}
            </p>
            <div className="underline" />
            <p className="description typography__paragraph">
              {get(welcomeContent, 'download.store', '')}
            </p>
            <Row className="logos" align="center" gutter={[16, 16]}>
              {map(get(welcomeContent, 'download.imageStore', []), (v, key) => (
                <Col xs={12} sm={8} md={12} lg={8} key={`${key}`}>
                  <a href={get(v, 'link', '')} target="_blank" rel="noreferrer">
                    <img
                      loading="lazy"
                      alt="stor_img"
                      src={`${getConfig('HOST_API')}${get(v, 'image.url', '')}`}
                    />
                  </a>
                </Col>
              ))}
            </Row>
          </Col>
        </Row>
      </section>
      <section className="container-fluid contact__content">
        <div className="contact__wrapper">
          <p className="text">
            <strong>{get(welcomeContent, 'contactUs.title', '')}</strong>
          </p>
          <p className="text">{get(welcomeContent, 'contactUs.subtitle', '')}</p>
          <p className="text">
            <a href={`tel:${get(welcomeContent, 'contactUs.phoneNumber', '')}`}>
              <img src="/assets/icons/phone.svg" alt="phone-icon" />
              <strong>{get(welcomeContent, 'contactUs.phoneNumber', '')}</strong>
            </a>
          </p>
          <p>{get(welcomeContent, 'contactUs.openingTime', '')}</p>
        </div>
      </section>
      <Footer style={{ textAlign: 'center' }}>
        {/* <a
        href="https://vercel.com?utm_source=create-next-app&utm_medium=default-template&utm_campaign=create-next-app"
        target="_blank"
        rel="noopener noreferrer">
        Powered by */}
        <img src="/assets/images/powerBy.svg" alt="True VWork Logo" className="" />
        {/* </a> */}
      </Footer>
    </Content>
  )
}

export default Home
